import React from 'react';
import {
    CircleIcon,
    FlightDetails,
    FlightDetailsContainer,
    FlightDetailsWrapper,
    FlightLogoWrapper,
    ProgressIcon,
    RowItem,
    TimeWrapper
} from "./styles";
import {StyledParagraph, StyledText, StyledTitle} from "../CustomAntdComponents/Typography";
import {ReactComponent as BusIcon} from "../../assets/images/bus-grey.svg";
import {getRoadTransportLogo} from "../AvailableBuses/helper";

type Props = {
    operator: BusResultItem,
    bus: AvailableBus,
}

const RoadCard = ({ operator, bus }: Props) => {

    return (
        <FlightDetailsContainer>
            <FlightDetails>
                <RowItem>
                    <TimeWrapper>
                        <StyledTitle level={5}>
                            {bus.EstimatedDepartureTime}
                        </StyledTitle>
                    </TimeWrapper>

                    <ProgressIcon>
                        <CircleIcon />
                    </ProgressIcon>

                    <FlightDetailsWrapper>
                        <StyledParagraph size="large">
                            {operator.DepartureTerminal}
                        </StyledParagraph>
                        <StyledParagraph>
                            {
                                bus.BoardingDetails && `${bus.BoardingDetails.Name}`
                            }
                        </StyledParagraph>
                    </FlightDetailsWrapper>
                </RowItem>

                <RowItem>
                    <TimeWrapper>
                        <StyledParagraph align="center">
                            {bus.Duration}
                        </StyledParagraph>
                    </TimeWrapper>

                    <ProgressIcon flight>
                        <BusIcon width={15} height={15} />
                    </ProgressIcon>

                    <FlightDetailsWrapper>
                        <div>
                            <FlightLogoWrapper>
                                <img
                                    src={bus.Operator?.Logo || getRoadTransportLogo(operator.AgentName)}
                                    alt={bus.Operator?.Name || operator.AgentName}
                                />
                            </FlightLogoWrapper>

                            <StyledText>
                                {bus.Operator?.Name || operator.AgentName}
                            </StyledText>
                        </div>
                        <StyledParagraph size="small">
                            {bus.BusType} | {`${bus.Capacity} seater`}
                        </StyledParagraph>
                    </FlightDetailsWrapper>
                </RowItem>

                <RowItem>
                    <TimeWrapper>
                        <StyledTitle level={5}>
                            {bus.EstimatedArrivalTime}
                        </StyledTitle>
                    </TimeWrapper>

                    <ProgressIcon>
                        <CircleIcon />
                    </ProgressIcon>

                    <FlightDetailsWrapper>
                        <StyledParagraph size="large">
                            {operator.ArrivalTerminal}
                        </StyledParagraph>
                        <StyledParagraph>
                            {
                                bus.DropOffDetails && `${bus.DropOffDetails.Name}`
                            }
                        </StyledParagraph>
                    </FlightDetailsWrapper>
                </RowItem>
            </FlightDetails>

        </FlightDetailsContainer>
    );
};

export default RoadCard;
